import {UIGameBaseShoreTileController} from './UIGameShoreTileControllerBase'
import {UIGameManager} from '../UIGameManager'
import {HexFace} from '@colonist/game-mechanic-validators'
import {UIGameMechanic} from '../UIGameEventController'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {FogTileGroupStates} from '@colonist/game-states'

export class UIGameGeneralShoreTileController extends UIGameBaseShoreTileController implements UIGameMechanic {
    private readonly fogTileGroupStates: FogTileGroupStates | undefined

    constructor(uiGameManager: UIGameManager, fogTileGroupStates: FogTileGroupStates | undefined) {
        super(uiGameManager)

        this.fogTileGroupStates = fogTileGroupStates

        const shoreHexes = this.findShoreHexes()
        const hexesAroundFog = this.findHexesAroundFog()
        const allPotentialShoreHexes = UIGameGeneralShoreTileController.getUniqueHexFaces([...shoreHexes, ...hexesAroundFog])
        this.createShoreTiles(allPotentialShoreHexes)

        this.uiGameManager.eventController.registerUIGameMechanic(this)
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.MapStateUpdated: this.updateShoreTiles(); break
            default: break
        }
    }

    private findShoreHexes(): HexFace[] {
        const shoreHexes: HexFace[] = []
        for(const tile of this.uiGameManager.gameController.mapValidator.tileState.tiles) {
            if(!tile.isTileLand()) continue

            for(const neighbor of tile.hexFace.neighbors()) {
                const neighborTile = this.uiGameManager.gameController.mapValidator.tileState.getTileHex(neighbor)
                if(neighborTile?.isTileLand()) continue

                const shoreHexesIncludesNeighbor = shoreHexes.some((face) => face.sameFace(neighbor))
                if(shoreHexesIncludesNeighbor) continue

                shoreHexes.push(neighbor)
            }
        }
        return shoreHexes
    }

    private findHexesAroundFog(): HexFace[] {
        if(this.fogTileGroupStates == undefined) return []

        const hexesAroundFogTiles: HexFace[] = []
        for(const fogTileGroupKey in this.fogTileGroupStates) {
            const fogTileGroup = this.fogTileGroupStates[fogTileGroupKey]
            if(fogTileGroup == undefined) continue

            for(const tileIndex of fogTileGroup.fogTileIndexes) {
                const tile = this.uiGameManager.gameController.mapValidator.tileState.tiles[tileIndex]
                if(tile == undefined) continue

                for(const neighbor of tile.hexFace.neighbors()) {
                    const hexesAroundFogTilesIncludesNeighbor = hexesAroundFogTiles.some((face) => face.sameFace(neighbor))
                    if(hexesAroundFogTilesIncludesNeighbor) continue

                    hexesAroundFogTiles.push(neighbor)
                }
            }
        }

        return hexesAroundFogTiles
    }

    private createShoreTiles(shoreHexes: HexFace[]) {
        for(const face of shoreHexes) {
            const tile = this.uiGameManager.gameController.mapValidator.tileState.getTileHex(face)
            if(tile?.isTileLand()) continue

            const data = this.getTextureAndAngle(face)
            this.createShoreTile(face, data.texture, data.angle)
        }
    }

    private updateShoreTiles() {
        for(const shoreTile of this.shoreTiles) {
            const tile = this.uiGameManager.gameController.mapValidator.tileState.getTileHex(shoreTile.hexFace)
            if(tile?.isTileLand()) continue

            const data = this.getTextureAndAngle(shoreTile.hexFace)
            shoreTile.tileSpriteView.texture = data.texture
            shoreTile.tileSpriteView.angle = data.angle
        }
    }

    private static getUniqueHexFaces(hexFaces: HexFace[]): HexFace[] {
        const uniqueHexFaces: HexFace[] = []
        for(const hexFace of hexFaces) {
            const hexFaceIncludes = uniqueHexFaces.some((face) => face.sameFace(hexFace))
            if(hexFaceIncludes) continue

            uniqueHexFaces.push(hexFace)
        }
        return uniqueHexFaces
    }
}
